const state = {
    hrteam:[],
};

const getters = {
    getHrTeam: state => state.hrteam,
};

const actions = {
    setHrTeam: (store, payload) => store.commit('HRTEAM_SET',payload),
};

const mutations = {
    HRTEAM_SET: (state, payload) => state.hrteam = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
